import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LowerTargetBufferModalComponent } from '@deltager/organizers/admin/modules/settlement-account/add-new-account/lower-target-buffer-modal/lower-target-buffer-modal.component';
import { TopUpBufferModalComponent } from '@deltager/organizers/admin/modules/settlement-account/add-new-account/top-up-buffer-modal/top-up-buffer-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AccountNumberService } from '@deltager/organizers/admin/core/services/account-number.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { PipesModule } from '@deltager/organizers/admin/shared/pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { BufferHistoryTableComponent } from '@deltager/organizers/admin/modules/settlement-account/add-new-account/buffer-history-table/buffer-history-table.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { OrganizerSettings } from '@deltager/organizers/admin/shared/models/OrganizerSettings';
import { selectOrganizer } from '@deltager/organizers/admin/redux/root.state';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '@deltager/organizers/admin/shared/components/base.component';

@Component({
  selector: 'app-account-buffer-edit',
  templateUrl: './account-buffer-edit.component.html',
  styleUrls: ['./account-buffer-edit.component.scss'],
  imports: [
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    TranslateModule,
    PipesModule,
    FormsModule,
    BufferHistoryTableComponent,
    MatTooltipModule,
    CurrencyPipe,
  ],
  standalone: true,
})
export class AccountBufferEditComponent extends BaseComponent implements OnInit {
  @Output() bufferChanged = new EventEmitter<AccountBufferOptions>();
  @Output() requestSave = new EventEmitter<boolean>();

  @Input()
  accountId = 0;

  @Input()
  isEditMode = false;

  @Input()
  set bufferAccountActivated(value: boolean) {
    this.initialBufferAccountActivated = value;
    this._bufferAccountActivated = value;
  }

  @Input() targetBufferAmount = 0;
  @Input() currentBufferAmount = 0;

  public organizerId = 0;
  public _bufferAccountActivated = false;
  public pendingPayouts = 0;
  public pendingRefunds = 0;
  public hasChanges = false;
  public currencyCode: string;

  private initialBufferAccountActivated = false;

  constructor(
    private dialog: MatDialog,
    private accountNumberService: AccountNumberService,
    private store: Store<{ organiser: OrganizerSettings }>,
  ) {
    super();
  }

  ngOnInit(): void {
    this.store
      .select(selectOrganizer)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(organizer => {
        this.currencyCode = organizer.currency;
        this.organizerId = organizer.id;
      });

    if (this.isEditMode) {
      this.getPendingAmounts();
    }
  }

  setHasChanges() {
    this.hasChanges = true;
    this.notifyTargetBufferAmountChange();
  }

  openLowerOrUncheckBufferDialog() {
    const dialogRef = this.dialog.open(LowerTargetBufferModalComponent, {
      width: '450px',
      height: '300px',
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(result => {
        if (result == true) {
          // On to off
          if (this.bufferAccountActivated == false && this.initialBufferAccountActivated) {
            this.targetBufferAmount = 0;
            this.notifyTargetBufferAmountChange();
          }
          this.requestSave.emit(true);
        }
      });
  }

  chkTargetBufferLowerThanCurrentBuffer() {
    if (
      this.targetBufferAmount < this.currentBufferAmount ||
      (this.bufferAccountActivated == false && this.initialBufferAccountActivated)
    ) {
      this.openLowerOrUncheckBufferDialog();
    } else {
      this.requestSave.emit(true);
    }
  }

  openTopUpBufferAmountModal() {
    this.dialog.open(TopUpBufferModalComponent, {
      width: '450px',
      height: '570px',
    });
  }

  getPendingAmounts() {
    this.accountNumberService
      .getPendingBufferAmounts(this.accountId, this.organizerId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(response => {
        this.pendingPayouts = response.pendingPayouts;
        this.pendingRefunds = response.pendingRefunds;
      });
  }

  notifyTargetBufferAmountChange() {
    this.bufferChanged.emit({
      bufferAccountActivated: this._bufferAccountActivated,
      targetBufferAmount: this.targetBufferAmount,
    } as AccountBufferOptions);
  }
}

export class AccountBufferOptions {
  bufferAccountActivated = false;
  targetBufferAmount = 0;
}
